<template>
    <v-container fluid class="white elevation-4 pt-0 pb-0">
        <main-app-bar :title="`Late - ${lateData.employee && lateData.employee}`">
            <template v-slot:buttons>
                <v-btn color="error" class="mr-4" @click="initPopupRemoveHoliday" :loading="deleteLoading" :disabled="deleteLoading">Delete</v-btn>
                <v-btn class="mx-4" @click="$router.go(-1)">Cancel</v-btn>
                <v-btn color="primary" :disabled="saveLoading" :loading="saveLoading" @click="saveLate">Save</v-btn>
            </template>
        </main-app-bar>
        <v-form ref="mainForm" class="holiday-form">
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-tooltip bottom max-width="200px">
                            <template v-slot:activator="{ on }">
                                <p class="holiday-form__main-tooltip"><v-icon color="grey" dark v-on="on">mdi-information</v-icon></p>
                            </template>
                            <p class="tooltip-fixed">
                                {{ tooltipDescription }}
                            </p>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="12" md="6">
                        <div class="mb-8">
                            <h3 class="ma-0 mb-3">Choose dates*</h3>
                            <v-menu
                                ref="menuRange"
                                v-model="menu"
                                :return-value.sync="dates"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="computedDatesFormatted"
                                        label="Date range"
                                        v-on="on"
                                        v-bind="attrs"
                                        readonly
                                        outlined
                                        dense
                                    />
                                </template>
                                <v-date-picker v-model="dates" range>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="saveDates(dates)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </div>
                        <div>
                            <h3 class="ma-0 mb-3">Attach files</h3>
                            <div class="file-upload-btn d-flex align-center">
                                <file-upload-button class="mb-2" v-model="attachments"
                                    :multiple="true">Browse
                                </file-upload-button>
                            </div>
                            <ul class="pa-0 mb-4" v-if="lateData.attachments">
                                <li class="d-flex align-center"
                                    v-for="(item, index) in lateData.attachments" :key="item.id">
                                    <a class="d-block flex-grow-1" @click="openImageGallery(index, item)">{{item.originalName}}</a>
                                    <v-spacer></v-spacer>
                                </li>
                            </ul>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <div>
                            <h3 class="ma-0 mb-3">Leave a comment</h3>
                            <v-textarea
                                outlined
                                name="input-7-4"
                                label="Leave a comment"
                                class="mb-5"
                                v-model="comment"
                            >
                            </v-textarea>
                        </div>
                        <div class="comments" v-if="lateData.comments">
                            <v-card class="d-flex flex-column grey lighten-3 pa-2 mb-5"
                                v-for="comment in lateData.comments" :key="comment.id">
                                <div class="d-flex justify-space-between  pb-2">
                                    <div class="font-weight-bold">{{comment.employee}}</div>
                                    <div class="d-flex justify-space-between align-center">
                                        <div style="width: 150px; font-size: 12px; text-align: right;">
                                            {{Date.getDateAndTime(comment.dateTime)}}
                                        </div>
                                    </div>
                                </div>
                                {{comment.text}}
                            </v-card>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <doc-view
            v-if="lateData.attachments"
            :isOpen="docViewOpen"
            :file-value="fileWatchData"
            :carouselIndex="carouselIndex"
            :uploadedImages="lateData.attachments.filter(item => isImage.includes(item.extension))"
            @closeModal="docViewOpen = false"
            @setActiveImg="setActiveImg(index)"
        >
        </doc-view>
    </v-container>
</template>
<script>
    import MainAppBar from '@/components/MainAppBar'
    import { mapActions, mapGetters } from 'vuex'
    import fileUploadButton from '@/components/FileUploadButton'
    import { TYPES_HOLIDAY, arrayTypesHoliday } from '@/constatns/typesOfHolidays'
    import DocView from '@/views/tasks/components/DocView'
    import moment from 'moment'

    export default {
        data () {
            return {
                getLoading: false,
                deleteLoading: false,
                lateData: {},
                tooltipDescription: null,
                rules: {
                    datespickerRules: [
                        v => (!!v && v.length > 0) || 'Please select date!'
                    ]
                },
                menu: false,
                dates: [],
                attachments: [],
                docViewOpen: false,
                carouselIndex: 0,
                fileWatchData: null,
                comment: '',
                saveLoading: false
            }
        },
        methods: {
            ...mapActions([
                'showAlert',
                'setLateAttachments',
                'getSingleLate',
                'lateCreate',
                'deleteLate'
            ]),
            saveDates (dates) {
                this.$refs.menuRange.save(dates.sort())
            },
            getDaysArray (start, stop) {
                const dateArray = []
                let currentDate = moment(start)
                const stopDate = moment(stop)
                while (currentDate <= stopDate) {
                    dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
                    currentDate = moment(currentDate).add(1, 'days')
                }
                return dateArray
            },
            setActiveImg (index) {
                this.carouselIndex = index
            },
            openImageGallery (startImageIndex, item) {
                this.carouselIndex = startImageIndex
                this.docViewOpen = true
                this.fileWatchData = item
            },
            async initPopupRemoveHoliday () {
                if (await this.$root.$confirmDialog.open('Late', null, null)) {
                    this.deleteLateHandler()
                }
            },
            async deleteLateHandler () {
                try {
                    this.deleteLoading = true
                    await this.deleteLate(this.$route.params.id)
                    this.deleteLoading = false
                    this.$router.go(-1)
                } catch (e) {
                    this.showAlert({
                        text: e.response.data.error,
                        type: 'error'
                    })
                    this.deleteLoading = false
                }
            },
            async saveLate () {
                if (!this.$refs.mainForm.validate()) {
                    this.showAlert({
                        text: 'Fill required fields!',
                        type: 'error'
                    })
                    return
                }
                const queryData = {
                    id: this.lateData.id,
                    employeeId: this.lateData.employeeId,
                    comment: this.comment.trim() ? this.comment.trim() : null
                }
                if (this.dates.length === 2) {
                    queryData.dates = this.getDaysArray(this.dates[0], this.dates[1])
                } else {
                    queryData.dates = this.dates
                }
                const attachmentForm = new FormData()
                if (this.attachments.length > 0) {
                    this.attachments.forEach(file => {
                        attachmentForm.append('files', file, file.name)
                    })
                }
                try {
                    this.saveLoading = true
                    if (this.attachments.length > 0) {
                        const attachmentsResponse = await this.setLateAttachments({ files: attachmentForm })
                        queryData.attachmentIds = attachmentsResponse.data.ids
                    }
                    await this.lateCreate(queryData)
                    this.showAlert({
                        text: 'Saved successfully!',
                        type: 'success'
                    })
                    this.saveLoading = false
                    this.$router.go(-1)
                } catch (e) {
                    this.showAlert({
                        text: e.response.data.error,
                        type: 'error'
                    })
                    this.saveLoading = false
                }
            }
        },
        computed: {
            ...mapGetters({
                getUserId: 'getUserId'
            }),
            computedDatesFormatted () {
                const localDates = this.dates.map((item) => {
                    return Date.getFormatDateStr(item)
                })
                return localDates.join(' ~ ')
            },
            isImage () {
                return ['.jpeg', '.jpg', '.png']
            }
        },
        async mounted () {
            const lateOptions = arrayTypesHoliday.filter(item => item.value === TYPES_HOLIDAY.LATE)[0]
            this.tooltipDescription = lateOptions.tooltipMessage
            try {
                this.getLoading = true
                const lateResponse = await this.getSingleLate(this.$route.params.id)
                this.lateData = lateResponse.data
                this.dates.push(lateResponse.data.date.split('T')[0])
                this.getLoading = false
            } catch (e) {
                this.getLoading = false
            }
        },
        components: {
            DocView,
            MainAppBar,
            fileUploadButton
        }
    }
</script>
<style lang="scss" deep>
    .holiday-form {
        position: relative;
        &__main-tooltip {
            position: absolute;
            top: 10px;
            right: 10px;
        }
    }

    .disabled {
        opacity: 0.6;
        pointer-events: none;
    }
</style>
